<template>
  <div class="home">
    <b-container class="bv-example-row">
      <b-row>
        <b-col class="p-0 menu">
          <Menu />
        </b-col cols="12" md="auto">
        <b-col>
          <Header />

          <b-container class="dashboard-content">

            All systems will appear here.<br />
            Online systems report heartbeats every five seconds, and system information every five minutes.<br />

            <Spinner v-show="showSpinner" /><br />



              <b-modal id="modal-lg" size="lg">
                <b>System Name:</b> {{ selectedSystem.system_name }}<br />
                <b>System Code:</b> {{ selectedSystem.system_code }}<br />
                <b>System IP:</b> {{ selectedSystem.system_ip }}<br />
                <b>System OS:</b> {{ selectedSystem.system_os }}<br />
                <b>System Displays:</b> {{ selectedSystem.system_displays }}<br />
                <b>Touch Build:</b> {{ selectedSystem.touch_build }}<br />
                <b>Touch Path:</b> {{ selectedSystem.touch_path }}<br />
                <b>Touch Project:</b> {{ selectedSystem.touch_project }}<br />
                <b>Touch Start Time:</b> {{ selectedSystem.touch_start_time }}<br />
                <b>Touch Heartbeat:</b> {{ selectedSystem.touch_heartbeat }}<br />
                <b>Touch FPS:</b> {{ selectedSystem.touch_fps }}<br />
              </b-modal>



            <b-table-simple hover small responsive borderless>
              <b-thead class="bg-dkblue text-white">
                <b-tr>
                  <b-th>System</b-th>
                  <b-th>IP Address</b-th>
                  <b-th>Project</b-th>
                  <b-th>Uptime</b-th>
                  <b-th style="width:3rem;" rowspan=2><b-link @click=""><b-icon @click="getSystems()" icon="arrow-clockwise" style="color: #fff"></b-icon></b-link></b-th>
                </b-tr>
              </b-thead>
              <!--<b-tbody>
                <b-tr class="table-row">
                  <b-th><b-form-input v-model="newWhitelistUser" class="table-input" type="email" placeholder="Add a new e-mail address"></b-form-input></b-th>
                  <b-td></b-td>
                  <b-td></b-td>
                  <b-td class="button-cell"><b-link @click=""><b-icon @click="addWhitelistUser()" icon="plus-square"></b-icon></b-link></b-td>
                </b-tr>
              </b-tbody>-->
              <b-tbody v-for="(sys, index) in systems">
                <b-tr class="table-row">

                  <b-th>{{ sys.system_name }}</b-th>
                  <b-td>{{ sys.system_ip }}</b-td>
                  <b-td>{{ sys.touch_project }}</b-td>
                  <b-td>{{ sys.uptime }}</b-td>
                  <b-td class="button-cell"><b-link @click="detailedInfo(sys)"><b-icon v-b-modal.modal-lg variant="primary" icon="three-dots"></b-icon></b-link></b-td>
                </b-tr>

              </b-tbody>
            </b-table-simple>



          </b-container>

        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/Menu.vue'
import Header from '@/components/Header.vue'
import Spinner from '@/components/Spinner.vue'
const axios = require('axios')

export default {
  name: 'dashboard',
  data(){
    return {
        showSpinner: false,
        systems: [],
        selectedSystem: ''
      }
  },
  mounted() {
    this.showSpinner = true,
    this.$store.state.page = "Dashboard"
    this.getSystems()
  },
  computed: {
    user () {
      return this.$store.state.user
      // { "logged": true, "loggedInAs": { "name": "Alok Wadhwani", "email": "alok@alokw.com" } }
    },
  },

  components: {
    Menu,
    Header,
    Spinner
  },

  methods: {

    detailedInfo(sys) {
        this.selectedSystem = sys;
    },

    getSystems() {
      this.showSpinner = true

      this.results = []
      var url = this.$store.state.locals.apiUrl + '/getSystems'
      var config = {
        method: 'get',
        url: url,
        headers: { 
          'api-key': this.$apikey, 
          'Content-Type': 'application/json'
        }
      };

      axios(config)
      .then((response) => {
        this.systems = response.data
        this.showSpinner = false

        for (let key in response.data) {

          var utcStamp = Math.floor( new Date().getTime() / 1000)

          let touch_start_time = response.data[key].touch_start_time
          let touch_start_stamp = Math.floor( new Date(touch_start_time)  / 1000)
          let touch_heartbeat = parseInt(response.data[key].touch_heartbeat)

          let time_since_heartbeat = utcStamp - touch_heartbeat
          let s = 0
          let uptime_note = ""


          // last heartbeat received within last ten seconds.... assume system is online
          if (time_since_heartbeat < 10) {
            // calculate time since startup
            s = touch_heartbeat - touch_start_stamp
            uptime_note = "Online "

          // otherwise heartbeat received over ten seconds ago.... assume system is offline
          } else {
            // calculate time since last heartbeat
            s = time_since_heartbeat
            uptime_note = "Offline "
          }

          const d = Math.floor(s / (3600 * 24));
          s  -= d * 3600 * 24;
          const h = Math.floor(s / 3600);
          s  -= h * 3600;
          const m = Math.floor(s / 60);
          s  -= m * 60;
          const tmp = [];

          (d) && tmp.push(d + 'd');
          (d || h) && tmp.push(h + 'h');
          (d || h || m) && tmp.push(m + 'm');

          tmp.push(s + 's');
          let uptime = tmp.join(' ');
          this.systems[key].uptime = uptime_note + uptime

        }

      })
      .catch((error) => {
        console.log(error);
        this.$store.state.error = error;
        this.$router.push('dashboard_error')
      });
    },
  }
    /*
  created: function() {
    
    const wssUrl = 'wss' + String(this.$store.state.locals.apiUrl).substring(5)
    console.log("Starting connection to WebSocket Server", wssUrl)

    
    this.connection = new WebSocket(wssUrl)

    this.connection.onmessage = function(event) {
      console.log(event);
    }

    this.connection.onopen = function(event) {
      console.log(event)
      console.log("Successfully connected to the echo websocket server...")
    }
    
  },*/
}
</script>
